import React from "react";

/** Wraps settings form fields (sidebar layout — no accordion). */
export default function SettingsSection({ panelMode = true, children }) {
  if (panelMode) {
    return <div className="settings-panel-body">{children}</div>;
  }
  return <div className="settings-panel-body">{children}</div>;
}
